import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'
import { convertParamsToString } from '@/shared/lib/queryParams'
import type {
  ChatConversationForHistory,
  ChatConversationDetail,
  ChatConversationsQueryParams,
} from '@intone/shared'

export function useChatConversationsForHistory(
  campaignId: number | null,
  params: ChatConversationsQueryParams
) {
  const apiClient = useApiClient()
  const queryString = convertParamsToString<ChatConversationsQueryParams>(params)

  return useQuery({
    queryKey: ['chat-conversations-history', campaignId, params],
    queryFn: async () => {
      return apiClient<{ conversations: ChatConversationForHistory[]; totalCount: number }>(
        `/chat-conversations/history/${campaignId}?${queryString}`
      )
    },
    enabled: !!campaignId && !!params.pageSize,
  })
}

export function useChatConversation(conversationId: string | null) {
  const apiClient = useApiClient()

  return useQuery({
    queryKey: ['chat-conversation', conversationId],
    queryFn: async () => {
      return apiClient<ChatConversationDetail>(
        `/chat-conversations/${conversationId}`
      )
    },
    enabled: !!conversationId,
    staleTime: 30_000,
  })
}
